// @ts-nocheck
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductFuturePrice, {
    ProductFuturePriceStyles,
} from "@store/Library/Components/ProductDetails/ProductFuturePrice";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProductContext;

export const productDetailsFuturePriceStyles: ProductFuturePriceStyles = {
    priceLabelTextFuturePrice: {
        css: css`
            &&& {
                font-size: ${pxToRem(18)};
            }
        `,
    },
};

const ProductDetailsFuturePrice: React.FC<OwnProps> = ({ productContext }) => {
    return <ProductFuturePrice product={productContext} overridedStyles={productDetailsFuturePriceStyles} />;
};

const widgetModule: WidgetModule = {
    component: withProductContext(ProductDetailsFuturePrice),
    definition: {
        displayName: "Price",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
